<template>
    <div :class="{'mini-dialog-overlay': overlay}" @click.self="handleOverlayClick" v-if="showing">
        <transition name="fade-modal">
            <div :class="{'mini-dialog': true, 'mini-dialog-wide': wide}" :id="uniqueModalId" v-if="showing">
                <close-icon @click.prevent="closeDialog"></close-icon>

                <h2>{{ title }}</h2>

                <slot></slot>

            </div>
        </transition>
    </div>
</template>

<script>
    import CloseIcon from './CloseIcon'
    import { v4 as uuid } from 'uuid'

    export default {
        name: 'MiniModal',
        props: {
            title: {
                //
            },
            name: {
                //
            },
            wide: {
                type: Boolean,
                default: false,
            },
            overlay: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            CloseIcon,
        },
        mixins: [
            //
        ],
        data() {
            return {
                uuid: null,
                showing: false,
                loaded: false,
            };
        },
        mounted() {
            this.loadData()

            this.uuid = uuid()

            this.$bus.$on('minimodal.show', function (name) {
                if (name == this.name) {
                    this.showing = true
                }
            }.bind(this))

            this.$bus.$on('minimodal.hide', function (name) {
                if (name == this.name) {
                    this.clearInputs()
                    this.showing = false
                }
            }.bind(this))

            this.showing = this.autoshow

            this.loaded = true
        },
        methods: {
            /**
             * Load the data to populate the list
             *
             * @return {void}
             */
            loadData (page) {
                //
            },
            /**
             * Close the dialog
             *
             * @return {void}
             */
            closeDialog () {
                this.showing = false
            },
            /**
             * Clear all inputs contained within the modal
             *
             * @return {void}
             */
            clearInputs () {
                var inputs = this.getAllInputs()
                for (var i = 0; i < inputs.length; i++) {
                    inputs[i].value = ''
                }
            },
            /**
             * Return all inputs located within this modal
             *
             * @return {NodeList}
             */
            getAllInputs () {
                return document.querySelectorAll('#mini-modal-' + this.uuid + ' input,#mini-modal-' + this.uuid + ' select,#mini-modal-' + this.uuid + ' textarea')
            },
            /**
             * Handle a click event on the overlay
             *
             * @return {void}
             */
            handleOverlayClick () {
                if (this.overlay) {
                    this.closeDialog()
                }
            },
        },
        watch: {
            showing (value) {
                if (value) {
                    this.$bus.$emit('modal.open')
                } else {
                    this.$bus.$emit('modal.close')
                }
            }
        },
        computed: {
            uniqueModalId () {
                return 'mini-modal-' + this.uuid
            }
        }
    }
</script>

<style lang="less">
.mini-dialog-overlay {
    background: rgba(45, 55, 66, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 109;
}

.mini-dialog {
    position: absolute;
    background: #FFFFFF;
    border-radius: 3px;
    width: 400px;
    height: auto;
    max-height: 90%;
    // min-height: 200px;
    overflow: auto;
    z-index: 102;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 1em;
    z-index: 110;

    &.mini-dialog-wide {
        width: 800px;
    }

    .close-icon {
        position: absolute;
        top: 10px;
        right: 1em;
    }

    h2 {
        text-transform: uppercase;
        color: #555555;
        font-size: 1em;
        font-weight: bold;
        margin: 0 0 0.75em 0;
        border-bottom: 1px solid #CCCCCC;
        padding-bottom: 0.25em;
    }
}

.fade-modal-enter-active {
    transition: all .3s;
    opacity: 1;
}
.fade-modal-enter {
    transition: all .3s;
    opacity: 0;
}
.fade-modal-leave-active {
    transition: all .3s;
    opacity: 0;
}
</style>
